import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import FilterPanel from 'components/Filters/FilterPanel'
import useFiltersManager from 'utils/hooks/useFiltersManager'
import config from 'modules/Finance/Wallets/subcomponents/Filters/filters'
import styles from 'modules/Finance/Wallets/Wallets.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'
import { RESET_FILTERS, SET_FILTERS } from 'modules/Finance/Wallets/types'

const Filters = ({ listMode }) => {
  const dispatch = useDispatch()
  const { filters } = useSelector((state) => state['finance/wallets'])

  const filterManager = useFiltersManager({
    filters: filters,
    config: config(listMode),
    setAction: SET_FILTERS,
  })

  useEffect(() => {
    dispatch({
      type: RESET_FILTERS,
      payload: filterManager.getMergedConfig(config(listMode)),
    })
  }, [listMode])

  return (
    <FilterPanel
      filterManager={filterManager}
      className={clsx(styles['wallets__filter-panel'], 'margin-bottom-32')}
    />
  )
}

Filters.propTypes = {
  listMode: PropTypes.oneOf(['transactions', 'promised-payments']),
}
export default Filters
